import { render, staticRenderFns } from "./MediaPage.vue?vue&type=template&id=4b2efd8e&scoped=true&"
import script from "./MediaPage.vue?vue&type=script&lang=js&"
export * from "./MediaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2efd8e",
  null
  
)

export default component.exports